var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-20.516%",
    y1: "50%",
    x2: "65.575%",
    y2: "-7.527%",
    id: "copy_svg__svg-2502931103a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68616",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE2A1E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.445 5.697c.707 0 1.29.583 1.29 1.29v9.699c0 .707-.583 1.29-1.29 1.29H1.34c-.707 0-1.29-.583-1.29-1.29v-9.7c0-.706.583-1.289 1.29-1.289h8.106zm-.027 1.29h-8.02l-.06 9.699h8.108l-.028-9.7zM16.661.024c.354 0 .675.144.91.377v.003h.002l.003.003c.232.234.376.555.376.907v9.7c0 .353-.144.674-.378.908l-.005.005a1.284 1.284 0 01-.908.377h-5.06v-1.29h5.06v-9.7H8.555V4.9h-1.29V1.316c0-.354.144-.675.378-.91l.003-.002h.002c.234-.234.554-.378.907-.378V.025h8.106z",
    fill: "#00264F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.445 5.697c.707 0 1.29.583 1.29 1.29v9.699c0 .707-.583 1.29-1.29 1.29H1.34c-.707 0-1.29-.583-1.29-1.29v-9.7c0-.706.583-1.289 1.29-1.289h8.106zm-.027 1.29h-8.02l-.06 9.699h8.108l-.028-9.7zM16.661.024c.354 0 .675.144.91.377v.003h.002l.003.003c.232.234.376.555.376.907v9.7c0 .353-.144.674-.378.908l-.005.005a1.284 1.284 0 01-.908.377h-5.06v-1.29h5.06v-9.7H8.555V4.9h-1.29V1.316c0-.354.144-.675.378-.91l.003-.002h.002c.234-.234.554-.378.907-.378V.025h8.106z",
    fill: "url(#copy_svg__svg-2502931103a)",
    opacity: 0
  }))));
}

export default SvgCopy;